import { createApp } from '@backstage/frontend-defaults';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import appPlugin from '@backstage/plugin-app';
import { navModule } from './modules/nav';
import { defectDojoPlugin } from './modules/defect-dojo';
import { deployMetricsPlugin } from './modules/deploy-metrics';
import { projectsRegistryPlugin } from './modules/projects-registry';
import { dependencyViewerPlugin } from './modules/dependency-viewer';
import { catalogSyncModule } from './modules/catalog-sync';
import { catalogSyncPagePlugin } from './modules/catalog-sync-page';
import { groupMembersPlugin } from './modules/group-members';
import { groupActionsPlugin } from './modules/group-actions';
import { relationsContentPlugin } from './modules/relations-content';
import { templateOverviewPlugin } from './modules/template-overview';
import { scaffolderGuardModule } from './modules/scaffolder-guard';
import { teamInfoPlugin } from './modules/team-info';
import { conditionalCardsPlugin } from './modules/api-cards';
import sonarqubePlugin from '@backstage-community/plugin-sonarqube/alpha';
import { sonarqubeOverviewPlugin } from './modules/sonarqube-overview';


const customApp = appPlugin.withOverrides({
  extensions: [
    appPlugin.getExtension('sign-in-page:app').override({
      params: {
        loader: async () =>
          (await import('./components/auth/LdapSignInPage')).default,
      },
    }),
  ],
});

export default createApp({
  features: [
    teamInfoPlugin,
    catalogSyncModule,
    catalogSyncPagePlugin,
    catalogGraphPlugin,
    orgPlugin,
    apiDocsPlugin,
    gitlabPlugin,
    userSettingsPlugin,
    notificationsPlugin,
    searchPlugin,
    scaffolderGuardModule,
    kubernetesPlugin,
    defectDojoPlugin,
    deployMetricsPlugin,
    projectsRegistryPlugin,
    dependencyViewerPlugin,
    groupMembersPlugin,
    groupActionsPlugin,
    relationsContentPlugin,
    templateOverviewPlugin,
    conditionalCardsPlugin,
    sonarqubePlugin,
    sonarqubeOverviewPlugin,
    navModule,
    customApp,
  ],
});
